/**
 * useSiteSettings — Hook public pour consommer les réglages CMS
 * du homepage (V2.5). Charge une fois puis met les résultats en cache.
 */
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

let cache = null;

export function useSiteSettings() {
  const [settings, setSettings] = useState(cache);
  const [loaded, setLoaded] = useState(!!cache);

  useEffect(() => {
    if (cache) return;
    let alive = true;
    fetch(`${API}/api/site-settings`)
      .then((r) => (r.ok ? r.json() : { settings: null }))
      .then((d) => {
        if (!alive) return;
        cache = d.settings || {};
        setSettings(cache);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
    return () => { alive = false; };
  }, []);

  return { settings: settings || {}, loaded };
}

export function invalidateSiteSettingsCache() {
  cache = null;
}
